<template>
    <div class="device">
        <div class="layout" style="margin-top:5.9375rem;">
            <div class="device-setting">
                <div class="layout-header" ref="searchBox" style="background:transparent;padding:1rem;width: calc(100% - 0.875rem);">
                  <div style="padding: 1rem; background: #FFF;">
                    <div class="infor-layout-header mb20">
                        <span class="title">禁停区管理</span>
                        <p>
                            <!-- <el-button type="primary" size="small" @click="add">上传资料</el-button> -->
                        </p>
                    </div>
                    <div>
                      <el-row type="flex" class="row-bg" justify="space-between">
                        <el-col :span="18">
                          <el-form :inline="true" :model="formInline" class="demo-form-inline">
                            <el-form-item label="禁停区名称：">
                              <el-input v-model="formInline.alias" :size="size" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="禁停区编号：">
                              <el-input v-model="formInline.serial" :size="size" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item>
                              <el-button type="primary" :size="size" @click="onSubmit" style="background-color: #3e7878;border-color: #3e7878">查询</el-button>
                              <el-button :size="size" @click="onReset">重置</el-button>
                            </el-form-item>
                          </el-form>
                        </el-col>
                        <el-col :span="6">
                          <div class="mt5 textRight">
                            <el-button v-if="userLevel >= 2 && isAggregation" type="primary" v-show="checkUserAuth(3, 117)" :size="size" @click="newSiteWl(null, false)">添加禁停区</el-button>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
                <div style="height:9.875rem;"></div>

                <div class="m16 pagination-bg-white device">
                    <w-table :bPagination="false" :height="tableViewHeight" :renderHeaderBySiteCeiling="renderHeaderBySiteCeiling"
                             :renderHeaderBySiteId="renderHeaderBySiteId" v-show="checkUserAuth(3, 119)"
                             v-loading.body="tableLoading" :data-list="tableData" :columns="staticData.noStoppingZone.columns"
                             :pageNo="formData.pageNum" :pageSize="formData.pageSize" :total="total"
                             :pageSizes="pageSizes" @pageNoChange="pageNoChange" @pageSizeChange="pageSizeChange">
                        <template slot-scope="props" slot="cell">
                            <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span>
                            <div v-if="props.column.label === '禁停区名称'">
                                <div>{{props.row.alias}}
                                </div>
                            </div>
                            <div v-else-if="props.column.label === '编号'">
                                <div>{{props.row.serial}}
                                </div>
                            </div>
                            <div v-else-if="props.column.label === '更新时间'">
                                <div class="table-line">
                                    {{props.row.updateTime | dateFormat('yyyy-MM-dd')}}
                                </div>
                            </div>
                            <div v-else-if="props.column.label === '上线时间'">
                                <div class="table-line">
                                    {{props.row.createTime | dateFormat('yyyy-MM-dd')}}
                                </div>
                            </div>
                            <div v-else-if="props.column.label === '操作'">
                                <!-- <span v-show="checkUserAuth(3, 120)" @click="newSiteWl(props.row, true)" class="blue">修改</span>
                                <template v-show="checkUserAuth(3, 118)">
                                  <span>｜</span>
                                  <span @click="deleteWlPre(props.row)" class="blue">删除</span>
                                </template> -->
                                <el-button v-show="checkUserAuth(3, 120)" class="btn-text" style="font-size:0.875rem;" @click="newSiteWl(props.row, true)" type="text" size="small">修改区域</el-button>
                                <el-button v-show="checkUserAuth(3, 118)" class="btn-text" style="font-size:0.875rem;" @click="deleteWlPre(props.row)" type="text" size="small">删除区域</el-button>
                            </div>
                            <span v-else>{{ props.row[props.column.property]}}</span>
                        </template>
                    </w-table>
                    <div v-show="!checkUserAuth(3, 119)">您的账户没有权限查看此内容！</div>
                </div>
            </div>
        </div>

        <w-dialog ref="w-dialog" :title="dialogTitle" :width="dialogWidth" :sureBtnText="sureBtnText"
                  @handleClose="handleClose" @handleCloseRight="handleClose" @onSure="onSure" :isShowFooter='false'>
            <template v-slot:content>
                <div class="dialog-content">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <div>
                            站点名称：<span v-if="detail" style="margin-right:2rem;">{{detail.siteName}}</span>
                            道钉编号：<span v-if="equipmentPower">{{equipmentPower.equipmentNo}}</span>
                        </div>
                        <el-tab-pane label="更新记录" name="first">
                            <w-table v-show="checkUserAuth(3, 20)" v-loading.body="tableLoadingPowerList"
                                     :data-list="tableDataPowerList" :columns="staticData.powerList.columns"
                                     :pageNo="formDataPowerList.pageNum" :pageSize="formDataPowerList.pageSize"
                                     :total="totalPowerList" @pageNoChange="pageNoChangePowerList"
                                     @pageSizeChange="pageSizeChangePowerList">
                                <template slot-scope="props" slot="cell">
                                    <!-- <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span> -->
                                    <div v-if="props.column.label === '更新方式'">
                                        <span :class="{green: props.row.type === 'app'}">{{getTypeStatus(props.row.type)}}</span>
                                    </div>
                                    <div v-else-if="props.column.label === '更新时间'">
                                        <span>{{props.row.createAt}}</span>
                                    </div>
                                    <span v-else>{{ props.row[props.column.property]}}</span>
                                </template>
                            </w-table>
                            <div v-show="!checkUserAuth(3, 20)">您的账户没有权限查看此内容！</div>
                        </el-tab-pane>
                        <el-tab-pane label="变化曲线图" name="second">
                            <div class="block text-right mtb10">
                                <el-date-picker v-show="checkUserAuth(3, 21) || checkUserAuth(3, 22)"
                                                @change="dayChange" v-model="day" type="daterange" range-separator="至"
                                                start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </div>
                            <!-- echarts -->
                            <div id="echarts"></div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </template>
        </w-dialog>
        <!-- w-dialog2 -->
        <w-dialog ref="w-dialog2" title="选择导出字段" width="50%" sureBtnText="导出" @handleClose="handleCloseExport"
                  @handleCloseRight="handleCloseExport" @onSure="onSureExport">
            <template v-slot:content>
                <div class="dialog-content">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
                    </el-checkbox>
                    <div style="margin: 0.9375rem 0;"></div>
                    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                        <el-checkbox style="display:block;margin-bottom:0.625rem;" v-for="city in deviceOptions"
                                     :label="city.key" :key="city.key">{{city.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </template>
        </w-dialog>
        <!-- 新增 -->
        <div class="my_content">
            <div class="my_mask" v-show="dialogNewSiteVisible"></div>
            <div class="my_new_site_dialog" v-show="dialogNewSiteVisible">
                <div class="my_new_site_dialog_title">
                    <div>新增禁停区</div>
                    <div style="cursor:pointer;" @click="closeNewSiteMask">x</div>

                </div>
                <div id="newSiteMap_nsz"></div>
                <div class="right_box">
                    <div class="right_box_item">
                        <div class="right_box_item_label">禁停区名称:</div>
                        <div class="right_box_item_value">
                            <el-input v-model="aliasName" size="mini" placeholder="请输入站点名称"></el-input>
                            <div class="err_msg" v-if="aliasNameErrMsg">{{aliasNameErrMsg}}</div>
                        </div>
                    </div>
                    <div class="right_box_item">
                        <div class="right_box_item_label">站点编号（填一个六位数）:</div>
                        <div class="right_box_item_value site_id_area">
                            <div class="site_id_area_front">{{platformCode}}</div>
                            <el-input v-model="serialName" :min="0" :max="999999" size="mini"
                                             placeholder="填一个六位数"></el-input>
                            <div class="err_msg" v-if="serialNameErrMsg">{{serialNameErrMsg}}</div>
                        </div>
                    </div>
                </div>
                <div class="handle_btns">
                    <el-button size="small" type="primary" @click="addSite">添加</el-button>
                    <el-button size="small" type="primary" @click="closeNewSiteMask">取消</el-button>
                </div>
            </div>
        </div>
        <div class="my_content">
            <div class="my_mask" v-show="dialogModifyWlVisible"></div>
            <div class="my_new_site_dialog" v-show="dialogModifyWlVisible">
                <div class="my_new_site_dialog_title">
                    <div>{{isEdit ? '编辑' : '新增'}}禁停区</div>
                    <div style="cursor:pointer;" @click="closeModifyResult">x</div>

                </div>
                <div id="modifySiteMap"></div>
                <div class="right_box">
                    <div class="right_box_item">
                        <div class="right_box_item_label">禁停区名称:</div>
                        <div class="right_box_item_value">
                            <el-input v-model="aliasName" size="mini" placeholder="请输入站点名称"></el-input>
                            <div class="err_msg" v-if="aliasNameErrMsg">{{aliasNameErrMsg}}</div>
                        </div>
                    </div>
                    <div class="right_box_item">
                        <div class="right_box_item_label">站点编号（填一个六位数）:</div>
                        <div class="right_box_item_value site_id_area">
                            <div class="site_id_area_front">{{platformCode}}</div>
                            <el-input v-model="serialName" maxlength="6" size="mini"
                                             placeholder="填一个六位数"></el-input>
                            <div class="err_msg" v-if="serialNameErrMsg">{{serialNameErrMsg}}</div>
                        </div>
                    </div>
                </div>
                <div class="map_handle_box_device">
                    <div class="title">绘制禁停区</div>
                    <div class="map_handles">
                        <div class="map_handle" v-if="!isEdit" :disabled="beginChartStatus" @click="beginChart">绘制多边形</div>
                        <div class="map_handle" @click="beginEditChart">开始编辑</div>
                        <div class="map_handle" @click="endEditChart">结束编辑</div>
                        <div class="map_handle" @click="clearPolygon">清除</div>
                    </div>
                </div>
                <div class="handle_btns">
                    <el-button size="small" type="primary" @click="saveModifyResult">保存</el-button>
                    <el-button size="small" type="primary" @click="closeModifyResult">取消</el-button>
                </div>
            </div>
        </div>
        <el-dialog
                title="修改站点"
                :visible.sync="dialogVisible"
                width="40%"
                class="modify_site_main"
                :before-close="handleEditSiteClose">
            <div>
                <div class="modify_site_item">
                    <div class="modify_site_item_label">站点名称：</div>
                    <div class="modify_site_item_value">
                        <el-input v-model="editSite.siteName" size="mini" placeholder="请输入站点名称"></el-input>
                    </div>
                </div>
                <div class="modify_site_item" v-if="editSite.source != '0'">
                    <div class="modify_site_item_label">站点编号：</div>
                    <div class="modify_site_item_value site_id_area">
                        <div class="site_front_area">{{editSite.siteFront}}</div>
                        <el-input type="text" v-model="editSite.siteEnd" size="mini" placeholder="请输入站点编号"></el-input>
                    </div>
                </div>
                <div class="modify_site_item" v-if="editSite.source != '0'">
                    <div class="modify_site_item_label">车位数：</div>
                    <div class="modify_site_item_value">
                        <el-input-number v-model="editSite.siteBikeCeiling" size="mini" placeholder="请输入车位数"></el-input-number>
                    </div>
                </div>
            </div>
            <div class="my_dialog-footer">
                <el-button @click="handleEditSiteClose" size="small">取 消</el-button>
                <el-button type="primary" @click="makeSureToModify" size="small">确 定</el-button>
            </div>

        </el-dialog>
    </div>
</template>

<script>
// @ is an alias to /src
import configJs from '../index'
import WDialog from '@/components/Model/index.vue'
import WTable from '@/components/Table/index.vue'
import WSearchs from '@/components/Searchs/index.vue'
import staticData from '../staticData.js'
import Api from '@/api'
import {
  mapGetters
} from 'vuex'
import {
  compare,
  getFilterParams,
  dateFormat,
  downloadExcel
} from '@/utils/tools'
import echarts from 'echarts'
import store from '../../../store'

var map = null
var modifyMap = null
var _this = null
var polygon = null
var polyEditor = null
export default {
  name: 'deviceManagement',
  components: {
    WDialog,
    WTable,
    WSearchs
  },
  data() {
    return {
      siteName: '', // 创建新站点弹窗的站点名称
      siteBikeCeiling: '', // 创建新站点弹窗的站点单车上限
      siteCeiling: '', // 创建新站点弹窗的站点设备上限
      siteLat: '', // 创建新站点弹窗的站点纬度
      siteLon: '', // 创建新站点弹窗的站点经度
      siteId: '', // 创建新站点弹窗的站点编号-后五位不要大于50000

      editSite: {}, // 编辑的站点信息
      pointArr: [], // 用来记录围栏的集合

      dialogVisible: false,
      dialogNewSiteVisible: false,
      beginChartStatus: false,
      dialogModifyWlVisible: false,
      isEdit: false,
      wlEditRow: {}, // 修改围栏的对象
      formData: {
        pageNum: 1,
        pageSize: 100
      },
      pageSizes: [100, 200, 500],
      total: 0,
      deviceTotal: 0,
      totalRole: 0,
      tableLoading: false,
      tableData: null,
      type: '',
      dialogTitle: '电池电量详情',
      dialogWidth: '60%',
      sureBtnText: '确定',
      detail: null,
      searchData: null,
      equipmentPower: null,
      totalPowerList: 0,
      formDataPowerList: {
        pageNum: 1,
        pageSize: 10
      },
      activeName: 'first',
      tableDataPowerList: null,
      tableLoadingPowerList: false,
      day: '',
      charts: '',
      // 导出
      deviceOptions: [
        {
          key: 1,
          label: '站点名称'
        },
        {
          key: 2,
          label: '站点编号'
        },
        {
          key: 3,
          label: '经度'
        },
        {
          key: 4,
          label: '纬度'
        },
        {
          key: 5,
          label: '道钉数'
        },
        {
          key: 6,
          label: '道钉编号'
        },
        {
          key: 7,
          label: 'MAC地址'
        },
        {
          key: 8,
          label: '信号强度'
        },
        {
          key: 9,
          label: '电池电量'
        },
        {
          key: 10,
          label: '上线时间'
        },
        {
          key: 11,
          label: '更新时间'
        },
        {
          key: 12,
          label: '车位数'
        },
        {
          key: 13,
          label: '创建时间'
        },
        {
          key: 14,
          label: '围栏数组'
        }
      ],
      checkedCities: [],
      isIndeterminate: true,
      checkAll: false,
      tableViewHeight: '',
      // 禁行区 / 禁停区
      configJs: configJs,
      formInline: {
        alias: '', // 名称
        serial: '' // 编号
      },
      size: 'small',
      aliasName: '', // 名称
      serialName: '', // 编号
      aliasNameErrMsg: '',
      serialNameErrMsg: ''
    }
  },
  computed: {
    ...mapGetters(['userLevel', 'isAggregation', 'areaAll', 'platformCode', 'user', 'selfAreaId', 'permissions', 'authorization', 'userSelfAreaId', 'globaleSelfAreaId', 'selfAddress']),
    staticData() {
      return staticData
    },
    currTab() {
      return this.configJs.find(item => item.active)
    }
  },
  created() {
    this.initData()
    // this.initRole()
    this.day = [
      new Date(this.getWeekBefore()),
      new Date(this.getToday())
    ]
  },
  mounted() {
    _this = this
    map = new AMap.Map('newSiteMap_nsz', {
      resizeEnable: true, // 允许缩放
      zoom: 15 　　　　　　 // 设置地图的缩放级别，0 - 20
    })
    map.on('click', function (ev) {
      // 触发事件的地理坐标，AMap.LngLat 类型
      var lnglat = ev.lnglat
      console.log('当前选中：', lnglat.getLng(), '----', lnglat.getLat())
      _this.siteLon = lnglat.getLng()
      _this.siteLat = lnglat.getLat()
      // 清除原有marker
      map.clearMap()
      // 创建一个 Marker 实例：
      var marker = new AMap.Marker({
        position: new AMap.LngLat(lnglat.getLng(), lnglat.getLat()) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      })

      // 将创建的点标记添加到已有的地图实例：
      map.add(marker)
    })

    modifyMap = new AMap.Map('modifySiteMap', {
      resizeEnable: true, // 允许缩放
      zoom: 15 　　　　　　 // 设置地图的缩放级别，0 - 20
    })
    modifyMap.on('click', function (ev) {
      console.log('您在[ ' + ev.lnglat.getLng() + ',' + ev.lnglat.getLat() + ' ]的位置点击了地图！')
      if (!_this.isEdit) {
        // 触发事件的对象
        if (!(_this.pointArr && _this.pointArr.length)) {
          // 已经点击了绘制的情况下，会给地图当前位置创建一个默认图层
          // 多边形轮廓线的节点坐标数组
          const lng = ev.lnglat.getLng()
          const lat = ev.lnglat.getLat()
          var path = [
            new AMap.LngLat(lng, lat),
            new AMap.LngLat(lng + 0.0005, lat),
            new AMap.LngLat(lng + 0.0005, lat + 0.0001),
            new AMap.LngLat(lng, lat + 0.0001)
          ]

          polygon = new AMap.Polygon({
            path: path,
            strokeColor: '#FF33FF',
            strokeWeight: 6,
            strokeOpacity: 0.2,
            fillOpacity: 0.4,
            fillColor: '#1791fc',
            zIndex: 50
          })

          // 初始化围栏
          _this.pointArr = []
          var b = polygon.getPath()
          for (var d = 0; d < b.length; d++) {
            _this.pointArr.push({
              lat: parseFloat(b[d].lat),
              lon: parseFloat(b[d].lng)
            })
          }

          modifyMap.add(polygon)
          modifyMap.setFitView([polygon])
          polyEditor = new AMap.PolyEditor(modifyMap, polygon)

          polyEditor.on('addnode', function (event) {
          })

          polyEditor.on('adjust', function (event) {
          })

          polyEditor.on('removenode', function (event) {
          })

          polyEditor.on('end', function (event) {
            _this.pointArr = []
            // event.target 即为编辑后的多边形对象
            console.log(event.target.getPath(), '--event.target---')
            var a = event.target.getPath()
            for (var q = 0; q < a.length; q++) {
              _this.pointArr.push({
                lat: parseFloat(a[q].lat),
                lon: parseFloat(a[q].lng)
              })
            }
            console.log(_this.pointArr, '--_this.pointArr--')
          })
          _this.beginChartStatus = false
        } else {
          _this.$message.warning('一次仅能创建一个围栏')
        }
      }
    })
  },
  methods: {
    onSubmit() {
      this.initData()
    },
    onReset() {
      this.formInline.alias = '' // 名称
      this.formInline.serial = '' // 编号
      this.initData()
    },
    tabChange(item) {
      // console.log(item)
      this.configJs.forEach(item => (item.active = false))
      const currTab = this.configJs.find(it => +it.id === +item.id)
      currTab.active = true
    },
    saveModifyResult() {
      if (!this.aliasName) {
        this.aliasNameErrMsg = '请输入禁停区名称'
        return
      } else {
        this.aliasNameErrMsg = ''
      }
      if (!this.serialName) {
        this.serialNameErrMsg = '请输入站点编号'
        return
      } else {
        this.serialNameErrMsg = ''
      }
      const params = {
        selfAreaId: this.selfAreaId,
        areaId: this.selfAreaId,
        id: this.wlEditRow && this.wlEditRow.id
      }
      let serial = this.platformCode
      if (String(this.serialName).length === 1) {
        serial = serial + '00000' + this.serialName
      } else if (String(this.serialName).length === 2) {
        serial = serial + '0000' + this.serialName
      } else if (String(this.serialName).length === 3) {
        serial = serial + '000' + this.serialName
      } else if (String(this.serialName).length === 4) {
        serial = serial + '00' + this.serialName
      } else if (String(this.serialName).length === 5) {
        serial = serial + '0' + this.serialName
      } else {
        serial = serial + '' + this.serialName
      }
      if (this.isEdit) {
        const data = {
          // siteId: this.wlEditRow.siteId,
          fence: JSON.stringify(this.pointArr),
          // areaId: this.selfAreaId,
          alias: this.aliasName,
          serial: serial
          // type: 0 // 0=禁停区,1=禁行区
        }
        // edit
        Api.putForbid(data, params).then(res => {
          console.log(res)
          if (res.code === 200) {
            // 删除成功
            this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
            this.closeModifyResult()
            this.onSearch()
          } else {
            this.$message.warning(res && res.message)
          }
        })
      } else {
        const data = {
          // siteId: this.wlEditRow.siteId,
          fence: JSON.stringify(this.pointArr),
          areaId: this.selfAreaId,
          alias: this.aliasName,
          serial: serial, // this.platformCode + '' + this.serialName,
          type: 0 // 0=禁停区,1=禁行区
        }
        // add
        Api.addForbid(data, params).then(res => {
          console.log(res)
          if (res.code === 200) {
            // 删除成功
            this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
            this.closeModifyResult()
            this.onSearch()
          } else {
            this.$message.warning(res && res.message)
          }
        }).catch(e => {
          console.log(e)
        })
      }
    },
    closeModifyResult() {
      this.aliasName = ''
      this.serialName = ''
      _this.pointArr = []
      polygon = null
      polyEditor && polyEditor.close()
      polyEditor = null
      this.dialogModifyWlVisible = false
    },
    makeSureToModify() {
      //
      let params = {}
      let data = {}
      if (this.editSite.source != '0') {
        params = {
          selfAreaId: _this.selfAreaId,
          originSiteId: _this.editSite.siteId,
          siteId: _this.editSite.siteFront + this.editSite.siteEnd,
          siteName: _this.editSite.siteName,
          siteBikeCeiling: _this.editSite.siteBikeCeiling
        }
      } else {
        data = {
          selfAreaId: _this.selfAreaId,
          originSiteId: _this.editSite.siteId,
          siteName: _this.editSite.siteName
        }
      }

      Api.modifySiteInfo(data, params).then(res => {
        console.log(res)
        if (res.code === 200) {
          // 删除成功
          _this.handleEditSiteClose()
          _this.onSearch(_this.searchData)
          _this.$message.success('编辑成功')
        } else {
          _this.$message.warning(res && res.message)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    handleEditSiteClose() {
      this.dialogVisible = false
      this.editSite = {}
    },
    addSite() {
      const params = {
        selfAreaId: this.selfAreaId,
        selectAreaId: this.selfAreaId,
        siteName: this.siteName,
        siteBikeCeiling: this.siteBikeCeiling,
        siteCeiling: this.siteCeiling,
        siteLat: this.siteLat,
        siteLon: this.siteLon,
        siteId: this.platformCode + this.siteId
      }
      Api.setSite(params).then(res => {
        console.log(res)
        if (res.code === 200) {
          // 删除成功
          this.closeNewSiteMask()
          this.$message.success('添加成功')

          this.onSearch(_this.searchData)
        } else {
          this.$message.warning(res && res.message)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    closeNewSiteMask() {
      // 关闭新建站点弹窗
      this.dialogNewSiteVisible = false
      map.clearMap()
      this.siteName = '' // 创建新站点弹窗的站点名称
      this.siteBikeCeiling = '' // 创建新站点弹窗的站点单车上限
      this.siteCeiling = '' // 创建新站点弹窗的站点设备上限
      this.siteLat = '' // 创建新站点弹窗的站点纬度
      this.siteLon = '' // 创建新站点弹窗的站点经度
      this.siteId = '' // 创建新站点弹窗的站点编号-后五位不要大于50000
    },
    newSite() {
      // 点击新增站点按钮
      this.closeNewSiteMask()
      this.dialogNewSiteVisible = true
    },
    // 关闭新增站点弹窗
    handleNewSiteClose() {

    },
    // 删除围栏
    deleteWlPre(row) {
      const vm = this
      const text = `你是否确定删除${row.alias}禁停区？`
      vm.$confirm(text, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vm.deleteWl(row)
      }).catch(() => {})
    },
    deleteWl(row) {
      console.log(row.siteId)
      const data = {
        id: row.id
      }
      const params = {
        selfAreaId: this.selfAreaId,
        areaId: this.selfAreaId
      }
      Api.delForbid(data, params).then(res => {
        console.log(res)
        if (res.code === 200) {
          // 删除成功
          this.$message.success('删除成功')
          this.onSearch()
        } else {
          this.$message.warning(res && res.message)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    modifySiteInfo(row) {
      // 修改站点信息
      console.log(row)
      this.editSite = { ...row }
      this.editSite.siteFront = row.siteId.substring(0, 8)
      this.editSite.siteEnd = row.siteId.substring(8)
      this.dialogVisible = true
    },
    makeEnclosure(pointList) {
      var path = []

      for (const i of pointList) {
        path.push(new AMap.LngLat(i.lon, i.lat))
        this.pointArr.push({
          lat: i.lat,
          lon: i.lon
        })
      }

      polygon = new AMap.Polygon({
        path: path,
        strokeColor: '#FF33FF',
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        fillColor: '#1791fc',
        zIndex: 50
      })

      var m3 = new AMap.Marker({
        position: [_this.wlEditRow.siteLon, _this.wlEditRow.siteLat]
      })

      modifyMap.add(polygon)
      // modifyMap.setFitView([m3])
      polyEditor = new AMap.PolyEditor(modifyMap, polygon)

      polyEditor.on('addnode', function (event) {
      })

      polyEditor.on('adjust', function (event) {
      })

      polyEditor.on('removenode', function (event) {
      })

      polyEditor.on('end', function (event) {
        _this.pointArr = []
        // event.target 即为编辑后的多边形对象
        console.log(event.target.getPath(), '--event.target---')
        var a = event.target.getPath()
        for (var q = 0; q < a.length; q++) {
          _this.pointArr.push({
            lat: parseFloat(a[q].lat),
            lon: parseFloat(a[q].lng)
          })
        }
        console.log(_this.pointArr, '--_this.pointArr--')
      })
    },
    getArea(adds, id) {
      const target = adds.find(item => item.id === id)
      if (target && target.parentId) {
        const p = adds.find(item => item.id === target.parentId)
        return p.areaName + target.areaName
      }
      return target.areaName
    },
    treeToList(tree, result = []) {
      tree.forEach(node => {
        result.push(node)
        node.child && this.treeToList(node.child, result)
      })
      return result
    },
    getRail(row) {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: this.selfAreaId,
          areaId: (row && row.areaId) || this.userSelfAreaId,
          selectAreaId: (row && row.areaId) || this.userSelfAreaId
        }
        Api.getRail(params)
          .then(res => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('获取区域围栏报错：', err)
            reject(err)
          })
      })
    },
    async newSiteWl(row, isEdit) {
      console.log(row, this.platformCode, isEdit)
      this.isEdit = isEdit
      modifyMap.clearMap()

      if (row && row.siteLon && row.siteLat) {
        var marker = new AMap.Marker({
          position: new AMap.LngLat(row.siteLon, row.siteLat) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        })
        // 将创建的点标记添加到已有的地图实例：
        modifyMap.add(marker)
      } else if (row && row.fence && JSON.parse(row.fence).length) {
        const fence = JSON.parse(row.fence)[0]
        const lon = fence.lon
        const lat = fence.lat
        console.log('lon', lon, ', lat', lat)
        const marker = new AMap.Marker({
          position: new AMap.LngLat(lon, lat) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        })
        // 将创建的点标记添加到已有的地图实例：
        modifyMap.add(marker)
        modifyMap.setZoom(18)
        modifyMap.setCenter(new AMap.LngLat(lon, lat))
      } else {
        const list = this.treeToList(this.areaAll)
        const address = this.getArea(list, this.selfAreaId)
        // 根据地名定位
        AMap.plugin('AMap.Geocoder', function() {
          var geocoder = new AMap.Geocoder()
          geocoder.getLocation(address, function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
              // 经纬度
              var lng = result.geocodes[0].location.lng
              var lat = result.geocodes[0].location.lat
              console.log('lng', lng, ', lat', lat)
              var marker = new AMap.Marker({
                position: new AMap.LngLat(lng, lat) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              })
              // 将创建的点标记添加到已有的地图实例：
              modifyMap.add(marker)
              modifyMap.setCenter(new AMap.LngLat(lng, lat))
            } else {
              console.log('定位失败！')
            }
          })
        })
      }

      this.wlEditRow = row
      this.pointArr = []

      // 绘制区域
      if (this.userLevel >= 2) {
        const rails = await this.getRail(row)
        if (rails && rails.code === 200 && rails.data && rails.data.length) {
          const fenceData = rails.data[0] && rails.data[0].gpsRally && JSON.parse(rails.data[0].gpsRally)
          if (fenceData && fenceData.length) {
            const fence = JSON.parse(rails.data[0].gpsRally)
            this.makeRailsEnclosure(fence)
          }
        }
      }
      if (isEdit) {
        // 编辑围栏
        this.aliasName = row.alias // 名称
        this.serialName = Number(row.serial.replace(this.platformCode, '')) // 编号
        this.makeEnclosure(JSON.parse(row.fence))
      } else {
        // 新增围栏
        if (row && row.fence) {
          this.newSetWl(JSON.parse(row.fence))
        }
        // 测试代码
        polygon && polygon.hide()
      }
      this.dialogModifyWlVisible = true
      if (row && row.siteLon && row.siteLat) {
        modifyMap.setCenter(new AMap.LngLat(row.siteLon, row.siteLat))
      }
    },
    makeRailsEnclosure(fence) {
      for (const item of fence) {
        if (item.paths && item.paths.length) {
          const path = []
          for (const i of item.paths) {
            path.push(new AMap.LngLat(i.lng, i.lat))
          }
          polygon = new AMap.Polygon({
            path: path,
            strokeColor: '#1890FF',
            strokeStyle: 'dashed',
            strokeWeight: 2,
            strokeOpacity: 1,
            fillOpacity: 0,
            fillColor: '',
            zIndex: 50
          })
          modifyMap.add(polygon)
        }
      }
    },
    newSetWl() {
      // 绘制围栏

    },
    // 设置中心点
    setSiteCenter(siteId) {
      const params = {
        selfAreaId: this.selfAreaId,
        areaId: this.selfAreaId,
        siteId: siteId
      }
      Api.putAreaCenter(params).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.onSearch(_this.searchData)
        } else {
          this.$message.warning(res && res.message)
        }
      })
    },
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // console.log('H', H)
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        // 30: tab修正
        this.tableViewHeight = window.innerHeight - 56 - H - 79 - 30
      })
    },
    renderHeaderBySiteId(h, {
      column
    }) { // h即为cerateElement的简写，具体可看vue官方文档
      return h(
        'div',
        [
          h('p', column.label),
          h('span', '(' + this.total + ')')
        ]
      )
    },
    renderHeaderBySiteCeiling(h, {
      column
    }) {
      return h(
        'div',
        [
          h('p', column.label),
          h('span', '(' + this.deviceTotal + ')')
        ]
      )
    },
    handleCheckAllChange(val) {
      console.log(val)
      this.checkedCities = val ? this.deviceOptions.map(it => it.key) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.deviceOptions.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.deviceOptions.length
    },
    handleCloseExport() {
      this.checkedCities = []
      this.isIndeterminate = true
      this.checkAll = false
      this.$refs['w-dialog2'].onCloseDialog()
    },
    showWdialog2(params) {
      if (params) {
        this.searchData = params
      }
      this.$refs['w-dialog2'].onShowDialog()
    },
    // 确认导出
    onSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = {
        selfAreaId: vm.selfAreaId
      }
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.userId = vm.user.id
      data.export = vm.checkedCities && vm.checkedCities.length ? vm.checkedCities.sort(compare).join(',') : ''
      data = getFilterParams(data)
      Api.downDeviceList(data, params)
        .then(res => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
    },
    dayChange(date) {
      const vm = this
      const beginDay = vm.getToday(date[0])
      const endDay = vm.getToday(date[1])
      const durationDay = vm.getEveryDateStr(beginDay, endDay)
      console.log(beginDay, endDay, durationDay)
      vm.initEquipmentPowerBetween(beginDay, endDay)
    },
    handleClick(tab, event) {
      if (this.activeName === 'second') {
        const beginDay = this.getToday(this.day[0])
        const endDay = this.getToday(new Date(this.getToday(this.day[1])).getTime() + (23 * 60 * 60 + 59 * 60 + 59) * 1000)
        this.initEquipmentPowerBetween(beginDay, endDay)
      }
    },
    initEquipmentPowerBetween(beginDay, endDay) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }

      if (beginDay === endDay) {
        const oneData = {
          equipmentMac: vm.equipmentPower.equipmentMac,
          day: beginDay
        }
        Api.getEquipmentPowerOne({
          ...oneData,
          ...params
        })
          .then(res => {
            if (res.code === 200) {
              if (res.data && res.data.length) {
                const avgTime = []
                const avgPower = []
                res.data.forEach(item => {
                  avgTime.push(item.avgTime)
                  avgPower.push(item.avgPower)
                })
                const options = this.getDrawLineParams(avgTime, avgPower)
                vm.drawLine('echarts', options)
              }
            } else {
              vm.$message.warning(res.message)
            }
          })
      } else {
        const data = {
          equipmentMac: vm.equipmentPower.equipmentMac,
          startDay: beginDay,
          endDay: endDay
        }
        Api.getEquipmentPowerBetween({
          ...data,
          ...params
        })
          .then(res => {
            if (res.code === 200) {
              if (res.data && res.data.length) {
                const avgTime = []
                const avgPower = []
                res.data.forEach(item => {
                  avgTime.push(item.avgTime)
                  avgPower.push(item.avgPower)
                })
                const options = this.getDrawLineParams(avgTime, avgPower)
                vm.drawLine('echarts', options)
              }
            } else {
              vm.$message.warning(res.message)
            }
          })
      }
    },
    drawLine(id, options) {
      this.charts = echarts.init(document.getElementById(id))
      this.charts.setOption({
        ...options,
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '2%',
          containLabel: true
        },

        toolbox: {
          feature: {
            saveAsImage: {}
          }
        }
      })
    },
    getDrawLineParams(avgTime, avgPower) {
      const options = {
        legend: {
          data: ['电量趋势']
        },
        // x抽
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: avgTime, // this.getEveryDateStr(this.getWeekBefore(), this.getToday()),
          // name: '日期', // x轴名称
          // x轴名称样式
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 18
          }

        },
        // y轴
        yAxis: {
          type: 'value',
          name: '电量趋势(%)', // y轴名称
          // y轴名称样式
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 18,
            marginRight: 30
            // color: '#D6D6D6'
          },
          splitLine: { // 网格线
            lineStyle: {
              type: 'dashed' // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true // 隐藏或显示
          }
        },
        series: [{
          name: '电量趋势(%)',
          type: 'line',
          stack: '总量',
          data: avgPower, // ['3', '2', '4', '4', '5', '100', '500'],
          color: '#1F8FFB'
          // borderType: 'dashed',
          // itemStyle: {
          //   normal: {
          //     lineStyle: {
          //       width: 2,
          //       type: 'dotted' // 'dotted'虚线 'solid'实线
          //     }
          //   }
          // }
        }]
      }
      return options
    },
    getToday(date) {
      // 返回 '2020-08-14'
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate())
    },
    getWeekBefore() {
      // 返回 '2020-08-07'
      const day1 = new Date()
      day1.setTime(day1.getTime() - 7 * 24 * 60 * 60 * 1000)
      return (day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate())
    },
    getEveryDateStr(begin, end) {
      // 返回 日期的数组 如 ['2020-08-07',...,'2020-08-14']
      var arr = []
      var ab = begin.split('-')
      var ae = end.split('-')
      var db = new Date()
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2])
      var de = new Date()
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2])
      var unixDb = db.getTime() - 24 * 60 * 60 * 1000
      var unixDe = de.getTime() - 24 * 60 * 60 * 1000
      // console.log(unixDb, unixDe)
      for (var k = unixDb; k <= unixDe;) {
        // console.log((new Date(parseInt(k))).format());
        k = k + 24 * 60 * 60 * 1000
        arr.push(dateFormat((parseInt(k))))
      }
      return arr
    },
    getTypeStatus(type) {
      let str = ''
      switch (type) {
        case 'app':
          str = '蓝牙道钉APP'
          break
        case 'ret':
          str = '租车还车'
          break
      }
      return str
    },
    onShowDialog(item, detail) {
      this.equipmentPower = item
      this.detail = detail
      this.getEquipmentPowerList()
    },
    getEquipmentPowerList() {
      const vm = this
      const params = {}
      vm.tableLoadingPowerList = true
      params.selfAreaId = this.selfAreaId
      params.currentPage = this.formDataPowerList.pageNum
      params.pageSize = this.formDataPowerList.pageSize
      params.equipmentMac = this.equipmentPower.equipmentMac
      Api.getEquipmentPowerList(params)
        .then(res => {
          if (res.code === 200) {
            vm.tableDataPowerList = res.data.lists
            vm.totalPowerList = res.data.total
            vm.$refs['w-dialog'].onShowDialog()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoadingPowerList = false
        })
    },
    onSure() {
      console.log('onSure')
    },
    showConfirm(textTitle, text, successFn, failFn) {
      this.$confirm(text, textTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        successFn && successFn.call(this)
      }).catch(() => {
        failFn && failFn.call(this)
      })
    },
    onDelEquipments(item, detail) {
      this.equipmentPower = item
      this.detail = detail
      this.showConfirm(
        '温馨提示',
        '你是否确定删除“' + detail.siteName + '”的' + item.equipmentNo + '道',
        () => {
          this.handleDelEquipments()
        },
        () => {
          this.handleClose()
        }
      )
    },
    handleDelEquipments(item) {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId,
        equipmentMac: this.equipmentPower.equipmentMac
      }
      const data = {
        equipmentMac: this.equipmentPower.equipmentMac
      }
      Api.deleteEquipment(data, params)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('蓝牙道钉删除成功！')
            vm.initData()
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    refreshAddress() {
      const vm = this
      const params = {
        selfAreaId: vm.globaleSelfAreaId,
        userAreaId: vm.globaleSelfAreaId
      }
      // 用户区域范围拉取
      params.areaId = vm.globaleSelfAreaId
      store.dispatch('user/setSideBarLoading', {
        value: true
      }).then(() => vm.noon)
      store.dispatch('user/getUserArea2', params).then(() => {
        store.dispatch('user/setSideBarLoading', {
          value: false
        }).then(() => vm.noon)
      })
      // if (Number(vm.globaleSelfAreaId)) { // 非 000000
      //   params.areaId = vm.globaleSelfAreaId
      //   store.dispatch('user/getUserArea2', params).then(() => vm.noon)
      // } else { // 000000
      //   store.dispatch('user/getAreaAll', params).then(() => vm.noon)
      // }
    },
    noon() {
    },
    onDelDevice(item) {
      this.detail = item
      this.showConfirm(
        '温馨提示',
        '你是否确定删除“' + item.siteName + '”站点？',
        () => {
          this.handleDelDevice(item)
        },
        () => {
          this.handleClose()
        }
      )
    },
    handleDelDevice(item) {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId
      }
      const data = {
        siteId: this.detail.siteId,
        areaId: this.detail.areaId
      }
      Api.deleteDeviceSite(data, params)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('站点删除成功！')
            vm.initData()
            // vm.refreshAddress()
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    // 开始绘制
    beginChart() {
      if (!this.beginChartStatus) {
        this.beginChartStatus = true
      }
    },
    beginEditChart() {
      polyEditor && polyEditor.open()
    },
    endEditChart() {
      polyEditor && polyEditor.close()
    },
    clearPolygon() {
      polygon && polygon.hide()
      this.pointArr = []
    },
    onSearch(params) {
      console.log('onSearch', params)
      this.searchData = params
      this.initData(true)
    },
    initData(type) {
      const vm = this
      vm.tableLoading = true
      let params = {
        ...vm.formInline,
        type: 0 // 0=禁停区,1=禁行区
      }
      // if (type) {
      //   this.formData.pageNum = 1
      // }
      params.selfAreaId = this.selfAreaId
      // params.currentPage = this.formData.pageNum
      // params.pageSize = this.formData.pageSize
      params = getFilterParams(params)
      Api.getForbidList(params)
        .then(res => {
          if (res.code === 200 && res.data) {
            vm.tableData = res.data
            // vm.total = res.data.length
            // vm.deviceTotal = res.data.pageSize
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
          vm.calcView()
        })
        .catch(err => {
          vm.tableLoading = false
          console.log(err)
        })
    },
    compare(property) {
      return function (a, b) {
        if (a[property] && b[property]) {
          return (a[property].charCodeAt() - b[property].charCodeAt())
        }
      }
    },
    handleClose(bo) {
      this.handleCloseBtn()
    },
    handleCloseBtn() {
      this.detail = null
      this.equipmentPower = null
      this.type = ''
      this.activeName = 'first'
      this.day = [
        new Date(this.getWeekBefore()),
        new Date(this.getToday())
      ]
      this.formDataPowerList.pageNum = 1
      this.formDataPowerList.pageSize = 10
      this.charts && this.charts.dispose()

      this.$refs['w-dialog'].onCloseDialog()
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.initData()
    },
    pageSizeChange(size) {
      this.formData.pageSize = size
      this.initData()
    },
    pageNoChangePowerList(page) {
      this.formDataPowerList.pageNum = page
      this.getEquipmentPowerList()
    },
    pageSizeChangePowerList(size) {
      this.formDataPowerList.pageSize = size
      this.getEquipmentPowerList()
    }
  }
}
</script>

<style lang="less">
    @import "../../../styles/index.less";
    .modify_site_main{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .my_dialog-footer{
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
        }
        .modify_site_item{
            display: flex;
            margin-bottom: 20px;
            flex-direction: row;
            align-items: center;

            &_label{
                min-width: 100px;
                text-align: right;
            }
            .site_front_area{
                font-size: 12px;
                width: 100px;
                display: flex;
                flex-direction: row;
                align-items: center;
                border-bottom-left-radius: 4px;
                border-top-left-radius: 4px;
                background: #D9D9D9;
                text-align: center;
                justify-content: center;
                border: 1px solid #D9D9D9;
            }
            &_value{
                display: flex;
            }
        }
    }
    .my_content {
        position: relative;

        .my_mask {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 2006;
            background: rgba(0, 0, 0, 0.5);
        }

        .my_new_site_dialog {
            position: fixed;
            padding: 0 30px 0 30px;
            box-sizing: border-box;
            left: 30px;
            right: 30px;
            bottom: 30px;
            top: 30px;
            z-index: 2007;
            background: #fff;

            &_title {
                height: 30px;
                line-height: 30px;
                display: flex;
                justify-content: space-between;
            }

            .right_box {
                position: absolute;
                padding: 10px;
                box-sizing: border-box;
                right: 0;
                top: 30px;
                width: 300px;
                height: calc(100% - 30px);
                background: #fff;

                .right_box_item {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin-bottom: 20px;

                    &_label {
                        min-width: 100px;
                        text-align: left;
                    }

                    &_value {
                        margin-top: 10px;
                    }

                    .site_id_area {
                        display: flex;
                        justify-content: center;
                        flex-direction: row;
                        align-items: center;

                        .site_id_area_front {
                            border: 1px solid #DCDFE6;
                            height: 28px;
                            line-height: 28px;
                            box-sizing: border-box;
                            border-right: 0;
                            padding: 0 10px;
                            border-bottom-left-radius: 4px;
                            border-top-left-radius: 4px;
                        }
                    }
                }
            }

            .handle_btns {
                height: 40px;

                line-height: 40px;
                display: flex;
                flex-direction: row;
                align-items: center;
            }
        }

        .map_handle_box_device {
            position: absolute;
            border-radius: 5px;
            right: 350px;
            bottom: 100px;
            width: 124px;
            height: 180px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            background: #fff;
            box-sizing: border-box;
            padding: 10px;

            .map_handles {
                margin-top: 10px;

                .map_handle {
                    cursor: pointer;
                    border-radius: 12px;
                    border: 1px solid #1F8FFB;
                    color: #1F8FFB;
                    padding: 2px 5px;
                    text-align: center;
                    margin-bottom: 10px;
                }
            }
        }
    }

    #newSiteMap_nsz {
        height: 90%;
    }
    #modifySiteMap {
        height: 90%;
    }

    .handle_btns {
        display: flex;
        flex-direction: column;
        color: #1F8FFB;
        justify-content: center;

        > div {
            cursor: pointer;
        }
    }

    .red {
        color: red;
    }

    .red-r {
        color: red;
    }

    .device-setting {
        background: rgba(240, 242, 245, 1);
        width: 100%;
        height: 100%;
        overflow-y: scroll;
    }

    .device {
        #echarts {
            width: 780px;
            height: 400px;
        }
    }

    .dialog-content {
        .content-header {
            padding-bottom: 16px;
            border-bottom: 1px solid #EBEBEB;

            .title {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: rgba(0, 0, 0, 0.85);
                margin-bottom: 16px;
            }

            .author {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.45);

                span {
                    margin-right: 32px;
                }
            }
        }

        .content-body {
            padding: 16px 0;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.45);
        }
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 21px;
        color: #8c939d;
        width: 112px;
        height: 112px;
        line-height: 112px;
        text-align: center;
        color: rgba(0, 0, 0, 0.25);
    }

    .avatar-uploader-text {
        position: absolute;
        bottom: 18px;
        left: 39px;
        color: rgba(0, 0, 0, 0.25);
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
    }

    .avatar {
        width: 112px;
        height: 112px;
        display: block;
    }

    .table-line,
    .table-line-no-border {
        height: 50px;
        line-height: 50px;
    }

    .table-line + .table-line {
        border-top: 1px solid #EBEBEB;
    }

    .device .el-table .cell {
        padding-right: 0;
        padding-left: 0;
    }
    .device-tab {
        height: 40px;
    }
    .err_msg {
      color: red;
      margin-top: 6px;
    }
    .blue {
      color: #409EFF;
      cursor: pointer;
    }
</style>
